export default class Person {
	constructor(attributes) {
		Object.assign(this, attributes)
	}

	get name() {
		if (this.lastName && this.firstName) return `${this.lastName}, ${this.firstName}`
		else if (this.lastName) return this.lastName
		else if (this.firstName) return this.firstName
	}

	getEmploymentActive(terminationDate) {
		return terminationDate ? "Terminated" : "Active"
	}
}
